import caesarPic from "@/public/images/artists/caesar.png";
import { Artist } from "@/types/types";

export const caesar = {
  id: "260",
  name: "Caesar",
  image: caesarPic,
  description: `Caesar has a bright, uplifting tone with a Latin flair, delivering melodies with smooth precision and a naturally energetic, pop-ready feel.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fcaesar-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Latin", "RnB", "Dance", "Pop", "Belting"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 70,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
